import React, { useCallback } from 'react';

import IMG_FORWARD from 'assets/images/ic_arrow_forward_white_48px.svg';
import InlineSpinner from 'components/generic/InlineSpinner.component';
import SvgIcon from 'components/generic/SvgIcon.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import call from 'utils/functions/call.util';

import CN from './FootButton.module.scss';

const FootButton = ({ disabled, isLoading, onClick, tag: tagFromProps, ...extra }) => {
  const tag = fromAnyToTrimmed(tagFromProps);

  const handleClick = useCallback(
    (ev) => {
      call(`FootButton.onClick`, onClick, { tag, ev, event: ev });
    },
    [onClick, tag],
  );

  return (
    <button
      tabIndex={0}
      {...extra}
      data-bem="FootButton"
      data-tag={tag}
      className={CN.component}
      onClick={handleClick}
      disabled={disabled}
    >
      {isLoading ? <InlineSpinner variant="light" /> : <SvgIcon alt="next button" tag={tag} icon={IMG_FORWARD} />}
    </button>
  );
};

export default FootButton;
